<template>
  <div class="loading-container" >
    <img :src="spinnerUrl" alt="Loading spinner" style="height: 100px;">
    <span class="message" v-if="message">{{message}}</span> 
  </div>
</template>
<script>
export default {
  name: 'LoadingSpinner',
  components: {},
  props: {
    message: String
  },
  data: function () {
    return {
    }
  },
  computed: {
    spinnerUrl() {
      return process.env.VUE_APP_HH_COMPONENTS_URL + "/spinner.svg"
    }
  },
  mounted () {},
  methods: {}
}
</script>

<style scoped>
.loading-container {
  padding-top: 150px;
}
.loading-container img {
  margin: auto;
  display: flex;
}
.message {
  padding-left: 40%;
}
</style>
